import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";

let _actx;
function _ctx() {
  try { _actx = _actx || new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { _actx = null; }
  return _actx;
}

// One short, gentle beep. iOS unlocks audio on first user gesture (see unlock effect).
export function playBeep() {
  const ctx = _ctx();
  if (!ctx) return;
  try {
    if (ctx.state === "suspended") ctx.resume();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.connect(g); g.connect(ctx.destination);
    o.type = "sine"; o.frequency.value = 660;
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.14, ctx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.25);
    o.start(); o.stop(ctx.currentTime + 0.26);
  } catch (e) { /* audio may be blocked until a user gesture */ }
}

// Spoken alert "Ada pesan baru masuk di Room Chat GBS" (id-ID). Falls back to the
// beep when speech synthesis is unavailable. iOS unlocks speech on first gesture.
export function playNewMessageAlert() {
  try {
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance("Ada pesan baru masuk di Room Chat GBS");
      u.lang = "id-ID";
      u.rate = 1.0;
      window.speechSynthesis.speak(u);
      return;
    }
  } catch (e) { /* fall through to beep */ }
  playBeep();
}

// Detects newly-arrived messages from OTHERS (isMine(m) === false, non-system) and fires
// a single toast + voice alert per message id. Tracks a tab-title unread counter while hidden.
export function useChatAlerts(messages, isMine, opts = {}) {
  const seen = useRef(new Set());
  const inited = useRef(false);
  const [titleUnread, setTitleUnread] = useState(0);
  const silent = !!opts.silent;

  useEffect(() => {
    const unlock = () => { const c = _ctx(); if (c && c.state === "suspended") c.resume(); try { window.speechSynthesis?.getVoices(); } catch (e) {} window.removeEventListener("pointerdown", unlock); };
    window.addEventListener("pointerdown", unlock, { once: true });
    const onVis = () => { if (!document.hidden) setTitleUnread(0); };
    document.addEventListener("visibilitychange", onVis);
    return () => { window.removeEventListener("pointerdown", unlock); document.removeEventListener("visibilitychange", onVis); };
  }, []);

  useEffect(() => {
    if (!Array.isArray(messages)) return;
    if (!inited.current) { messages.forEach((m) => m.id && seen.current.add(m.id)); inited.current = true; return; }
    const fresh = messages.filter((m) => m.id && !seen.current.has(m.id));
    fresh.forEach((m) => seen.current.add(m.id));
    const incoming = fresh.filter((m) => m.sender_kind !== "system" && !isMine(m));
    if (incoming.length) {
      if (!silent) playNewMessageAlert();
      const last = incoming[incoming.length - 1];
      const preview = last.type === "location" ? "📍 Berbagi lokasi" : (last.text || "").slice(0, 60);
      toast(`${last.sender_name}: ${preview}`);
      if (document.hidden) setTitleUnread((n) => n + incoming.length);
    }
  }, [messages, isMine, silent]);

  return { titleUnread };
}
